"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBackground = void 0;

var _background = require("../constants/background");

var _useOptions = require("../constants/useOptions");

var getColourPattern = function getColourPattern(useOption) {
  return _background.COLOUR_MAPPINGS[useOption];
};

var getBackground = function getBackground(_ref) {
  var use = _ref.use;
  return use === _useOptions.BLANK ? _background.BLANK_BACKGROUND : (0, _background.makeGradientBackground)(getColourPattern(use));
};

exports.getBackground = getBackground;